import React, { useState } from "react";
import { Tabs as Abas, Tab, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import TabEmpresa from "./TabEmpresa";
import TabApiCredenciais from "./TabApiCredenciais";
import TabNotificacao from "./TabNotificacao";
import TabMapeamento from "./TabMapeamento";
import TabScheduler from "./TabScheduler";


function TabsIFS({
  touched,
  values,
  errors,
  handleChange,
  setFieldValue,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana,
  aplicacaoId,
}) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <ModernContainer>
      <Abas selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Empresa</Tab>
          <Tab>API</Tab>
          <Tab>Notificação</Tab>
          <Tab>Mapeamento</Tab>
          <Tab>Scheduler</Tab>
        </TabList>
        <TabPanel>
          <TabEmpresa
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            onTestConnect={onTestConnect}
            onTestConnectHana={onTestConnectHana}
            connected={connected}
            connectedHana={connectedHana}
            isLoading={isLoading}
            isLoadingHana={isLoadingHana}
          />
        </TabPanel>
        <TabPanel>
          <TabApiCredenciais
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
          />
        </TabPanel>
        <TabPanel>
          <TabNotificacao
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </TabPanel>
        <TabPanel>
          <TabMapeamento
            values={values}
            setFieldValue={setFieldValue}
            aplicacaoId={aplicacaoId}
          />
        </TabPanel>
        <TabPanel>
          <TabScheduler
            values={values}
            setFieldValue={setFieldValue}
          />
        </TabPanel>
      </Abas>
    </ModernContainer>
  );
}

const ModernContainer = styled.div`
  width: 100%;
  font-family: 'Mulish', sans-serif;

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }

  .react-tabs__tab-list {
    border-bottom: 2px solid #e2e8f0 !important;
    margin: 0 0 24px !important;
    padding: 0 !important;
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
  }

  .react-tabs__tab {
    padding: 12px 24px !important;
    border: none !important;
    background: transparent !important;
    cursor: pointer !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #64748b !important;
    border-bottom: 3px solid transparent !important;
    transition: all 0.3s ease !important;
    font-family: 'Mulish', sans-serif !important;
    outline: none !important;
    list-style: none !important;
    position: relative !important;
    margin: 0 !important;

    &:hover {
      color: #ff6b35 !important;
      background: rgba(255, 107, 53, 0.05) !important;
      border-radius: 8px 8px 0 0 !important;
    }
  }

  .react-tabs__tab--selected {
    color: #ff6b35 !important;
    border-bottom-color: #ff6b35 !important;
    background: rgba(255, 107, 53, 0.05) !important;
    border-radius: 8px 8px 0 0 !important;
  }

  .react-tabs__tab--disabled {
    color: #cbd5e1 !important;
    cursor: not-allowed !important;

    &:hover {
      color: #cbd5e1 !important;
      background: transparent !important;
    }
  }

  .react-tabs__tab:focus {
    box-shadow: none !important;
  }

  .react-tabs__tab-panel {
    display: none !important;
    animation: fadeIn 0.3s ease !important;
  }

  .react-tabs__tab-panel--selected {
    display: block !important;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default TabsIFS;
